import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SousService } from 'app/models/sous-service';
import { Observable, Subject, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SousServiceService {
  base_path = 'https://app.titv-store-api.com/';
  
  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNedeed() {
    return this.refreshData;
  }

  // ✅ ADD: Token retrieval method
  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  // ✅ ADD: Headers with token
  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    
    if (token) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      });
    }
    
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ✅ ADD: Error handling
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    }
    
    console.error('Erreur SousServiceService:', errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  createSousService(item: any, idProduit: any): Observable<SousService> {
    const headers = this.getHeaders();
    
    return this.http.post<SousService>(
      this.base_path + 'services/sous/add/' + idProduit, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // Get single SousService data by ID
  getSousService(id: any): Observable<SousService> {
    const headers = this.getHeaders();
    
    return this.http.get<SousService>(
      this.base_path + 'services/sous/' + id,
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Get SousServices data
  getListSousService(): Observable<SousService[]> {
    const headers = this.getHeaders();
    
    return this.http.get<SousService[]>(
      this.base_path + 'services/sous/all',
      { headers }
    ).pipe(
      catchError(this.handleError)
    );
  }

  // Update item by id
  updateSousService(id: any, item: any): Observable<SousService> {
    const headers = this.getHeaders();
    
    return this.http.put<SousService>(
      this.base_path + 'services/sous/update/' + id, 
      JSON.stringify(item), 
      { headers }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // ✅ FIXED: Delete item by id - Expect 'text' response to avoid JSON parse error
  deleteSousService(id: any): Observable<string> {
    const headers = this.getHeaders();
    
    return this.http.delete(
      this.base_path + 'services/sous/delete/' + id, 
      { 
        headers,
        responseType: 'text' // <--- THIS IS THE KEY FIX
      }
    ).pipe(
      tap(() => {
        this.refreshData.next();
      }),
      catchError(this.handleError)
    );
  }

  // sous-service.service.ts (add this method)
  updateSousServiceOrder(id: number, displayOrder: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(
      this.base_path + 'services/sous/update-order/' + id,
      displayOrder,  // backend expects Integer directly in body
      { headers, responseType: 'text' }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError)
    );
  }
}